export interface TimelineItem {
    id: number;
    year: string;
    title: string;
}

export const timelineData: TimelineItem[] = [
    {
        id: 1,
        year: '2005',
        title: 'G&G Auto Sales LLC \nEstablished',
    },
    {
        id: 2,
        year: '2005',
        title: 'Tampa, FL \nBranch opening',
    },
    {
        id: 3,
        year: '2008',
        title: 'Miami, FL \nBranch opening',
    },
    {
        id: 4,
        year: '2010',
        title: 'Savannah, GA \nBranch opening',
    },
    {
        id: 5,
        year: '2011',
        title: 'W8 Shipping LLC \nEstablished',
    },
    {
        id: 6,
        year: '2012',
        title: 'Houston, TX \nBranch opening',
    },
    {
        id: 7,
        year: '2013',
        title: 'New York, NY \nBranch opening',
    },
    {
        id: 8,
        year: '2018',
        title: 'Los Angeles, CA \nBranch opening',
    },
    {
        id: 9,
        year: '2020',
        title: 'Seattle, WA \nBranch opening',
    },
    {
        id: 10,
        year: '2025',
        title: 'Norfolk, VA \nBranch opening',
    },
];
